import React from 'react';
import { AccommodationCard } from './AccommodationCard';
export const AccommodationList = ({
  accommodations,
  onHover,
  selectedPOIs,
  poiCategories
}) => {
  return <div className="space-y-6" data-id="element-116">
      <h2 className="text-xl font-bold" data-id="element-117">Places to stay</h2>
      <div className="grid grid-cols-1 gap-6" data-id="element-118">
        {accommodations.map(accommodation => <AccommodationCard key={accommodation.id} accommodation={accommodation} onHover={() => onHover(accommodation.id)} onLeave={() => onHover(null)} selectedPOIs={selectedPOIs} poiCategories={poiCategories} data-id="element-119" />)}
      </div>
    </div>;
};